import { useState } from "react";

// A community's face in lists: its logo when it has one, otherwise its initial on its brand colour.
// `flagged` adds a red dot instead of repainting the whole mark, so the brand still shows.
export function CommunityMark({ tenant, size = 40, rounded = "rounded-xl", flagged = false, testid }) {
  const [broken, setBroken] = useState(false);
  const brand = tenant?.brand || {};
  const color = brand.color || "#191614";
  const logo = brand.logo && tenant?.id && !broken ? `${process.env.REACT_APP_BACKEND_URL}/api/public/tenant/${tenant.id}/logo` : "";
  const initial = (tenant?.name || "?").trim().charAt(0).toUpperCase();
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testid}>
      {logo ? (
        <div className={`h-full w-full ${rounded} bg-white border flex items-center justify-center overflow-hidden p-[3px]`} style={{ borderColor: `${color}55` }}>
          <img src={logo} alt="" onError={() => setBroken(true)} className="max-h-full max-w-full object-contain" data-testid={testid ? `${testid}-logo` : undefined} />
        </div>
      ) : (
        <div className={`h-full w-full ${rounded} flex items-center justify-center font-heading font-bold text-white shadow-sm`}
          style={{ backgroundColor: color, fontSize: Math.round(size * 0.42) }} data-testid={testid ? `${testid}-initial` : undefined}>{initial}</div>
      )}
      {flagged && <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-redline-500 ring-2 ring-white" title="Needs attention" />}
    </div>
  );
}
